<template>
  <app-layout-site>
    <div class=" transacao-list">
      <div class="card5">
        <app-loader :loading="loadingControl.show">
          <div class="container">
            <div class="card-form">
              <h3>Transações Banco - Adicionar</h3>
              <ValidationObserver v-slot="{ invalid }">
                <form @submit.prevent="submit">
                  <div class="form-group">
                    <label for="ipt-value">Valor</label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <app-input-money id="ipt-value" v-model="form.value"
                                       :show-nullable="false"></app-input-money>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="ipt-date">Data da Transação</label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <app-datetime-picker id="ipt-date"
                                           v-model="form.date"
                                           output-format='YYYY-MM-DD HH:mm:ss'
                                           format="YYYY-MM-DD hh:mm a"
                                           :min-date="datepicker.minDate"
                                           :max-date="datepicker.maxDate"
                      >
                      </app-datetime-picker>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="ipt-bank_account_id">Conta Bancaria</label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <app-multiselect
                        id="ipt-bank_account_id"
                        placeholder="Selecione uma opção"
                        v-model="multiselect.bankAccount.selected"
                        :options="multiselect.bankAccount.options"
                        :searchable="true"
                        :allow-empty="true"
                        :close-on-select="true"
                        track-by="id"
                        :custom-label="(item)=> { return item.account + '-' + item.agency }"
                        @input="(selected) => {form.bank_account_id = selected !== null? selected.id : null}"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <div class="option__bank-account_bank-logo">
                            <img :src="BankService.bankIcon(props.option.bank_code)">
                          </div>
                          <div class="option__bank-account_detail">
                            <div class="option__bank-account_agency">
                              {{
                                props.option.agency +
                                (props.option.agency_check
                                !== null ? '-' +
                                  props.option.agency_check : '')
                              }}
                            </div>
                            <div class="option__bank-account_account">{{
                                props.option.account +
                                (props.option.account_check !== null ? '-' +
                                  props.option.account_check : '')
                              }}
                            </div>
                          </div>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__bank-account_bank-logo">
                            <img :src="BankService.bankIcon(props.option.bank_code)">
                          </div>
                          <div class="option__bank-account_detail">
                            <div class="option__bank-account_agency">{{
                                props.option.agency +
                                (props.option.agency_check
                                !== null ? '-' +
                                  props.option.agency_check : '')
                              }}
                            </div>
                            <div class="option__bank-account_account">{{
                                props.option.account +
                                (props.option.account_check !== null ? '-' +
                                  props.option.account_check : '')
                              }}
                            </div>
                          </div>
                          <span class="status"></span>
                        </template>
                      </app-multiselect>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for="ipt-institution_origin_id">Categoria de Lançamento</label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <app-multiselect
                        id="ipt-institution_origin_id"
                        placeholder="Pesquise e selecione"
                        v-model="multiselect.bankLaunchCategory.selected"
                        :options="multiselect.bankLaunchCategory.options"
                        :loading="multiselect.bankLaunchCategory.loading"
                        :searchable="true"
                        :allow-empty="true"
                        :close-on-select="true"
                        label="name"
                        track-by="id"
                        @input="multiselectBankLaunchCategoryInput"
                      >
                        <template slot="option" slot-scope="props">
                          <div class="option__bank_launch_category_detail">
                            <div class="name">
                              <div class="id">{{ props.option.id }}</div>
                              <div class="value">{{ props.option.name }}</div>
                            </div>
                            <div class="category">{{ props.option.type === 'C' ? 'Crédito' : 'Débito' }}</div>
                          </div>
                          <span class="status"></span>
                        </template>
                      </app-multiselect>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for="ipt-value">Histórico do Lançamento</label>
                    <div class="description">Descrição do histórico do lançamento, presente no extrato bancário.
                      Exemplo:
                      <div class="badge-code-container">
                        <div class="badge-code">DEP.DINH.CASH IA</div>
                        <div class="badge-code">DEP ONLINE TAA</div>
                        <div class="badge-code">RESGATE APLIC. FINANCEIRA</div>
                      </div>
                    </div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input id="ipt-bank-launch-history" type="text" v-model="form.bank_launch_history"
                             class="form-control"/>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="ipt-value">Código do Lançamento</label>
                    <div class="description">Código do lançamento no banco, presente no extrato bancário. Exemplo:
                      <div class="badge-code-container">
                        <div class="badge-code">0830</div>
                        <div class="badge-code">0500</div>
                      </div>
                    </div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input id="ipt-bank-launch-code" type="text" v-model="form.bank_launch_code"
                             class="form-control"/>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for="ipt-value">Número do Lançamento</label>
                    <div class="description">Número do documento comprobatório do lançamento, presente no extrato
                      bancário. Exemplo:
                      <div class="badge-code-container">
                        <div class="badge-code">781871452150614</div>
                      </div>
                    </div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input id="ipt-bank-launch-number" type="text" v-model="form.bank_launch_number"
                             class="form-control"/>
                      <span class="msg-error" v-if="errors[0]">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <button class="btn btn-primary btn-block" :disabled="invalid">salvar</button>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </app-loader>
      </div>
    </div>
  </app-layout-site>
</template>

<script>
import AppLayoutSite from '/src/components/layouts/site'
import DetailsProvider from '/src/features/transactions/providers/transaction-details'
import AppDatetimePicker from '/src/components/date-time-picker'
import AppInputMoney from '/src/components/input-money/component'
import AppLoader from '/src/components/loader'
import moment from 'moment'
import loadingMixin from '/src/features/transactions/components/mixins/loading'
import BankAccountProvider from '/src/features/settings/components/register/providers/bank-accounts'
import AppMultiselect from '/src/components/multiselect'
import BankService from '/src/utils/icon-banks'
import _ from 'lodash'

const minDate = moment('20180101', 'YYYYMMDD').format('YYYY-MM-DD')
const maxDate = moment().format('YYYY-MM-DD')


export default {
  name: 'transacao-edit',
  mixins: [
    loadingMixin
  ],
  components: {
    AppLoader,
    AppLayoutSite,
    AppMultiselect,
    AppDatetimePicker,
    AppInputMoney
  },
  mounted() {
    // this.multiselectBankAccountsPreLoad()
    // this.multiselectBankLaunchCategoryPreLoad()
    this.editLoad()
  },
  data: function () {
    return {
      multiselect: {
        bankAccount: {
          loading: false,
          selected: null,
          options: []
        },
        bankLaunchCategory: {
          loading: false,
          selected: null,
          options: []
        }
      },
      datepicker: {
        minDate: minDate,
        maxDate: maxDate
      },
      form: {
        date: null,
      },
      BankService: BankService,
    }
  },
  methods: {
    submit() {
      let self = this
      this.loadingIncrement()

      DetailsProvider.updateTransactionBank(this.form)
        .then((response) => {
          self.response = response.data
        })
        .finally(() => {
          self.loadingDecrement()
          this.$router.push({name: 'transactions-bank-index'})
        })
    },
    editLoad() {
      let self = this
      self.loadingIncrement()

      this.findById(this.$route.params.id)
        .then((item) => {
          if (item == null) {
            return
          }

          this.form.id = item.id
          this.form.value = parseFloat(item.value)
          this.form.date = item.date
          this.form.coupon_code = item.coupon_code
          this.form.bank_launch_history = item.bank_launch_history
          this.form.bank_launch_code = item.bank_launch_code
          this.form.bank_launch_number = item.bank_launch_number

          this.multiselectBankLaunchCategoryByIdAndSelected(item.bank_launch_category_id)
          this.form.bank_launch_category_id = item.bank_launch_category_id

          this.multiselectBankAccountsByIdAndSelected(item.bank_account_id)
          this.form.bank_account_id = item.bank_account_id
        })
        .finally(() => {
          self.loadingDecrement()
        })
    },
    findById(id) {
      let self = this
      self.loadingIncrement()

      return new Promise((resolve, reject) => {
        BankAccountProvider
          .findTransactionBankByIdEdit(id)
          .then(res => {
            resolve(res.data)
          })
          .catch((e) => {
            reject(e)
          })
          .finally(() => {
            self.loadingDecrement()
          })
      })
    },
    multiselectBankLaunchCategoryByIdAndSelected(id) {
      let self = this
      self.loadingIncrement()
      BankAccountProvider.getBankLaunchCategory()
        .then(res => {
          self.loadingDecrement()
          self.multiselect.bankLaunchCategory.options = res.data

          if (this.multiselect.bankLaunchCategory.options.length === 0) {
            return;
          }

          let item = _.find(this.multiselect.bankLaunchCategory.options, (e) => e.id === id)
          if (item !== undefined) {
            this.multiselect.bankLaunchCategory.selected = item
            this.multiselectBankLaunchCategoryInput(item)
          }
        })

    },
    multiselectBankLaunchCategoryInput(selected) {
      this.form.bank_launch_category_id = selected !== null ? selected.id : null
    },

    // multiselectBankLaunchCategoryPreLoad() {
    //     let self = this
    //     BankAccountProvider.getBankLaunchCategory()
    //         .then(res => {
    //             self.multiselect.bankLaunchCategory.options = res.data
    //         })
    // },
    // multiselectBankAccountsPreLoad() {
    //     let self = this
    //     BankAccountProvider.get()
    //         .then(res => {
    //             self.multiselect.bankAccount.options = _.orderBy(res.data, 'bank_code')
    //         })
    // },
    multiselectBankAccountsByIdAndSelected(id) {
      let self = this
      self.loadingIncrement()
      BankAccountProvider.get()
        .then(res => {
          self.loadingDecrement()
          self.multiselect.bankAccount.options = _.orderBy(res.data, 'bank_code')

          if (this.multiselect.bankAccount.options.length === 0) {
            return
          }

          let item = _.find(this.multiselect.bankAccount.options, (e) => e.id === id)

          if (item !== undefined) {
            this.multiselect.bankAccount.selected = item
          }
        })

    },

  }
}
</script>
